import type {IconBase} from '../../types/global';
import {getColors} from '../../utils/styles';

const colors = getColors();

export const DocumentIcon = ({color = colors.charcoal, className = '', ratio = 1}: IconBase) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  const colorValue = colors[color] || (color as string);

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={colorValue}
        d="M27,29H5c-.4,0-.57.01-.77-.29-.3-.3-.23-.31-.23-.71V5c0-.4-.02-1.01.14-1.43.18-.44.46-.57.86-.57h22c.4,0,.63.13.83.53s.17,1.07.17,1.47v23c0,.4-.03.43-.31.65-.32.26-.29.35-.69.35h0ZM26,27V5H6v22h20ZM10,9h12v2h-12v-2ZM10,14h12v2h-12v-2ZM10,19h8v2h-8v-2Z"
      />
    </svg>
  );
};
